export type Coordinate = { lat: number; lng: number };
export const fallbackSite: Coordinate = { lat: 49.565, lng: 7.07 };

export function readCoordinate(value: unknown): Coordinate | null {
  if (!value || typeof value !== "object") return null;
  const point = value as { lat?: unknown; lng?: unknown };
  const number = (part: unknown) => typeof part === "number" ? part : typeof part === "string" && part.trim() !== "" ? Number(part) : NaN;
  const lat = number(point.lat);
  const lng = number(point.lng);
  // The existing empty-position template uses 0/0. A single zero is a valid coordinate.
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0) ? { lat, lng } : null;
}

export function yardNearSite(site: unknown): Coordinate {
  const base = readCoordinate(site) ?? fallbackSite;
  const lng = base.lng + 0.0025;
  return { lat: base.lat, lng: lng > 180 ? lng - 360 : lng };
}

export function sameCoordinate(first: Coordinate | null, second: Coordinate | null): boolean {
  return first !== null && second !== null && first.lat === second.lat && first.lng === second.lng;
}
